import {Account} from "../../../../core/entities/account/domain/model/account.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export interface IAccountCreatedPayload {
  account: Account;
}

export class AccountCreatedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'AccountCreatedEvent';

  constructor(readonly payload?: IAccountCreatedPayload) {
  }
}
